'use strict';

/**
 * @ngdoc function
 * @name scrapQApp.controller:SalesAgentBusinessReportCtrl
 * @description
 * # SalesAgentBusinessReportCtrl
 * Sales Agent -> Client -> REO report.
 * Leads (sales agent -> client mobile) come from the sales API,
 * completed services (client mobile -> REO) come from the ScrapQ API.
 */
angular.module('scrapQcrmApp')
    .controller('SalesAgentBusinessReportCtrl', function ($scope, tableState, $q, $global, authentication, $filter, $moment, $stateParams, $rootScope, salesAgentService, growl) {

        $scope.inrFilter = $filter('INR');

        // the report opens on all-time data; a DD-MMM-YYYY range passed to the page opens that range instead
        let fromParam = typeof $stateParams.fromdate === 'string' ? $moment($stateParams.fromdate, 'DD-MMM-YYYY', true) : null;
        let toParam = typeof $stateParams.todate === 'string' ? $moment($stateParams.todate, 'DD-MMM-YYYY', true) : null;
        if (fromParam && toParam && fromParam.isValid() && toParam.isValid()) {
            $scope.date = { startDate: fromParam.toDate(), endDate: toParam.toDate() };
        } else {
            $scope.date = { startDate: null, endDate: null };
        }
        $scope.isAllTime = true;

        $scope.vm = {
            params: { "city": $rootScope.loginData.city }
        };

        $rootScope.loginData = $global.getLocalItem("loginData", true);

        // agent id not in this city's sales team list (active or inactive)
        const NOT_IN_TEAM = "Not in team";

        $scope.leads = null; // leads assigned to a sales agent, loaded once
        $scope.salesAgentsData = [];
        $scope.reportsData = [];
        $scope.selectedSalesAgent = null;
        $scope.labelCounts = {};

        // long numbers on the cards (e.g. ₹1,23,45,678.00) get a smaller font so they stay inside the card
        $scope.cardNumberStyle = function (value) {
            let length = value === undefined || value === null ? 0 : value.toString().length;
            if (length > 15) {
                return { 'font-size': '18px', 'line-height': '33px' };
            }
            if (length > 11) {
                return { 'font-size': '22px', 'line-height': '33px' };
            }
            return {};
        };

        (function () {

            var data = {
                "city": $rootScope.loginData.city,
                "userType": $rootScope.loginData.role,
                "module": "Reports",
                "subModule": "SalesAgentClientWise",
                "type": "Other"
            };

            authentication.getUserRoleMetrics(data).then(function (res) {
                if (res.status == "SUCCESS") {
                    $scope.disabledFeilds = res.data.userRoleMatrix[0].disabledFields;
                    [$scope.summaryGridOptions, $scope.detailsGridOptions].forEach(function (gridOptions) {
                        gridOptions.columnDefs = gridOptions.columnDefs.filter(function (col) {
                            return !$scope.disabledFeilds.includes(col.field);
                        });
                        if (gridOptions.api) {
                            gridOptions.api.setColumnDefs(gridOptions.columnDefs);
                        }
                    });
                } else {
                    $scope.disabledFeilds = [];
                }
            }).catch(function (err) {
                $scope.disabledFeilds = [];
            })
        })();

        (function () {

            function AmountCellRenderer() {
            }

            AmountCellRenderer.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                let val = params.value ? $scope.inrFilter(params.value) : '0.00';
                this.eGui.innerHTML = "<div> " + val + "</div>";
            };

            AmountCellRenderer.prototype.getGui = function () {
                return this.eGui;
            };

            let defaultColDef = {
                flex: 1,
                minWidth: 130,
                filter: true,
                sortable: true,
                resizable: true,
                columnsMenuParams: {
                    suppressColumnFilter: true,
                    contractColumnSelection: true,
                }
            };

            let summaryColumnDefs = [
                { headerName: "Sales Agent", field: "salesAgentName", flex: 2, cellStyle: { 'text-align': 'left' } },
                { headerName: "Sales Agent Personal Mobile", field: "salesAgentMobile", cellStyle: { 'text-align': 'left' } },
                // Active / Inactive as on the Sales Team page; "Not in team" = no longer in the team list
                { headerName: "Status", field: "agentStatus", maxWidth: 140, cellStyle: statusCellStyle,
                    headerTooltip: "Active / Inactive as on the Sales Team page. Not in team = the agent is not in this city's sales team list (another city, removed, or a test account)" },
                { headerName: "Leads", field: "clientsBrought", cellStyle: { 'text-align': 'right' } },
                { headerName: "Active Clients", field: "activeClients", cellStyle: { 'text-align': 'right' } },
                { headerName: "Services Done", field: "servicesCount", cellStyle: { 'text-align': 'right' } },
                { headerName: "Qty (kg + pcs)", field: "totalQuantity", cellStyle: { 'text-align': 'right' }, cellRenderer: AmountCellRenderer },
                { headerName: "Business (₹)", field: "gtv", cellStyle: { 'text-align': 'right' }, cellRenderer: AmountCellRenderer },
                { headerName: "First Service", field: "firstServiceDate", comparator: dateComparator, cellStyle: { 'text-align': 'left' } },
                { headerName: "Last Service", field: "lastServiceDate", comparator: dateComparator, cellStyle: { 'text-align': 'left' } }
            ];

            let detailsColumnDefs = [
                { headerName: "Sales Agent", field: "salesAgentName", cellStyle: { 'text-align': 'left' } },
                // the arrow on the client opens the client's visit history
                { headerName: "Client", field: "clientName", flex: 2, minWidth: 220, cellRenderer: 'agGroupCellRenderer', tooltipField: 'clientName' },
                { headerName: "Client Mobile", field: "clientMobile", cellStyle: { 'text-align': 'left' } },
                // a client served by several REOs lists all of them; hover shows the full list
                { headerName: "REO", field: "reoName", tooltipField: "reoName", cellStyle: { 'text-align': 'left' } },
                { headerName: "REO Mobile", field: "reoMobile", tooltipField: "reoMobile", cellStyle: { 'text-align': 'left' } },
                { headerName: "Services Done", field: "servicesCount", cellStyle: { 'text-align': 'right' } },
                { headerName: "Qty (kg + pcs)", field: "totalQuantity", cellStyle: { 'text-align': 'right' }, cellRenderer: AmountCellRenderer },
                { headerName: "Business (₹)", field: "gtv", cellStyle: { 'text-align': 'right' }, cellRenderer: AmountCellRenderer },
                { headerName: "First Service", field: "firstServiceDate", comparator: dateComparator, cellStyle: { 'text-align': 'left' } },
                { headerName: "Last Service", field: "lastServiceDate", comparator: dateComparator, cellStyle: { 'text-align': 'left' } },
                { headerName: "Shared With", field: "sharedWith", cellStyle: { 'text-align': 'left' } }
            ];

            // visit history shown when a client row is expanded
            let visitColumnDefs = [
                { headerName: "Service Date", field: "serviceDate", comparator: dateComparator, maxWidth: 130 },
                { headerName: "Appointment ID", field: "appointmentId", maxWidth: 140 },
                { headerName: "REO", field: "reoName", maxWidth: 170 },
                { headerName: "Items", field: "items", flex: 5, tooltipField: "items", valueFormatter: itemsFormatter },
                { headerName: "Qty (kg + pcs)", field: "totalQuantity", maxWidth: 140, cellStyle: { 'text-align': 'right' }, cellRenderer: AmountCellRenderer },
                { headerName: "Amount (₹)", field: "gtv", maxWidth: 120, cellStyle: { 'text-align': 'right' }, cellRenderer: AmountCellRenderer },
                { headerName: "Payment", field: "paymentMethod", maxWidth: 100 }
            ];

            // one row per visit - used only for the "Download All Services" Excel
            let servicesColumnDefs = [
                { headerName: "Sales Agent", field: "salesAgentName" },
                { headerName: "Client", field: "clientName" },
                { headerName: "Client Mobile", field: "clientMobile" },
                { headerName: "REO", field: "reoName" },
                { headerName: "Service Date", field: "serviceDate" },
                { headerName: "Appointment ID", field: "appointmentId" },
                { headerName: "Items", field: "items", valueFormatter: itemsFormatter },
                { headerName: "Qty (kg + pcs)", field: "totalQuantity" },
                { headerName: "Amount (₹)", field: "gtv" },
                { headerName: "Payment", field: "paymentMethod" }
            ];

            function dateComparator(a, b) {
                let dateA = a ? $moment(a, 'DD-MMM-YYYY').valueOf() : 0;
                let dateB = b ? $moment(b, 'DD-MMM-YYYY').valueOf() : 0;
                return dateA - dateB;
            }

            function statusCellStyle(params) {
                let color = params.value === 'Active' ? '#21a548' : (params.value === 'Inactive' ? '#d9534f' : 'gray');
                return { 'text-align': 'left', 'color': color };
            }

            function itemsFormatter(params) {
                return params.value ? params.value : "No items recorded";
            }

            [summaryColumnDefs, detailsColumnDefs, visitColumnDefs].forEach(function (columnDefs) {
                columnDefs.forEach(function (colObj) {
                    colObj.headerTooltip = colObj.headerTooltip || colObj.headerName;
                });
            });

            function getRowStyle(params) {
                if (params.node.rowIndex % 2 === 0) {
                    return { background: 'white' };
                }
            }

            $scope.summaryGridOptions = {
                columnDefs: summaryColumnDefs,
                defaultColDef: defaultColDef,
                tooltipShowDelay: 0,
                suppressCsvExport: false,
                suppressExcelExport: false,
                rowStyle: { background: '#f4f4f4', cursor: 'pointer' },
                rowSelection: 'single',
                pagination: true,
                rowData: [],
                paginationPageSize: 50,
                domLayout: 'autoHeight',
                getRowStyle: getRowStyle,
                // clicking a sales agent shows only that sales agent's clients below
                onRowClicked: function (params) {
                    $scope.$applyAsync(function () {
                        $scope.selectedSalesAgent = params.data.salesAgentName;
                        $scope.setDetailsRows();
                    });
                },
                onGridReady: function (params) {
                    params.api.setRowData($scope.salesAgentsData);
                },
                onFirstDataRendered: function (params) {
                    params.api.sizeColumnsToFit();
                }
            };

            $scope.detailsGridOptions = {
                columnDefs: detailsColumnDefs,
                defaultColDef: defaultColDef,
                tooltipShowDelay: 0,
                suppressCsvExport: false,
                suppressExcelExport: false,
                rowStyle: { background: '#f4f4f4' },
                pagination: true,
                rowData: [],
                paginationPageSize: 50,
                domLayout: 'autoHeight',
                getRowStyle: getRowStyle,
                masterDetail: true,
                detailCellRendererParams: {
                    detailGridOptions: {
                        columnDefs: visitColumnDefs,
                        defaultColDef: { flex: 1, minWidth: 110, sortable: true, resizable: true },
                        tooltipShowDelay: 0,
                        onFirstDataRendered: function (params) {
                            params.api.sizeColumnsToFit();
                        }
                    },
                    getDetailRowData: function (params) {
                        params.successCallback(params.data.services || []);
                    }
                },
                // height of the expanded visit history: grows with the number of visits, scrolls after 8
                getRowHeight: function (params) {
                    if (params.node && params.node.detail) {
                        let visits = (params.data.services || []).length;
                        return 120 + Math.min(Math.max(visits, 1), 8) * 42;
                    }
                },
                onGridReady: function (params) {
                    params.api.setRowData($scope.reportsData);
                },
                onFirstDataRendered: function (params) {
                    params.api.sizeColumnsToFit();
                }
            };

            $scope.servicesGridOptions = {
                columnDefs: servicesColumnDefs,
                rowData: [],
                suppressCsvExport: false,
                suppressExcelExport: false
            };

        })();

        $scope.setDetailsRows = function () {
            let rows = $scope.reportsData;
            if ($scope.selectedSalesAgent) {
                rows = rows.filter(function (row) {
                    return row.salesAgentName === $scope.selectedSalesAgent;
                });
            }
            if ($scope.detailsGridOptions.api) {
                $scope.detailsGridOptions.api.setRowData(rows);
            }

            // one row per visit, for the "Download All Services" Excel
            let serviceRows = [];
            rows.forEach(function (row) {
                (row.services || []).forEach(function (visit) {
                    serviceRows.push({
                        salesAgentName: row.salesAgentName,
                        clientName: row.clientName,
                        clientMobile: row.clientMobile,
                        reoName: visit.reoName,
                        serviceDate: visit.serviceDate,
                        appointmentId: visit.appointmentId,
                        items: visit.items,
                        totalQuantity: visit.totalQuantity,
                        gtv: visit.gtv,
                        paymentMethod: visit.paymentMethod
                    });
                });
            });
            if ($scope.servicesGridOptions.api) {
                $scope.servicesGridOptions.api.setRowData(serviceRows);
            }
        };

        $scope.showAllSalesAgents = function () {
            $scope.selectedSalesAgent = null;
            if ($scope.summaryGridOptions.api) {
                $scope.summaryGridOptions.api.deselectAll();
            }
            $scope.setDetailsRows();
        };

        // Excel downloads follow what is on screen (selected sales agent, filters, sorting)
        function fileFrom() {
            return $scope.isAllTime ? "All-Time" : $scope.vm.params.fromdate;
        }

        function fileTo() {
            return $scope.isAllTime ? "All-Time" : $scope.vm.params.todate;
        }

        $scope.downloadClientsExcel = function () {
            $global.exportGridToExcel($scope.detailsGridOptions, "Sales_Agent_Clients", fileFrom(), fileTo(), $scope.selectedSalesAgent);
        };

        $scope.downloadServicesExcel = function () {
            $global.exportGridToExcel($scope.servicesGridOptions, "Sales_Agent_All_Services", fileFrom(), fileTo(), $scope.selectedSalesAgent);
        };

        $scope.downloadSalesAgentsExcel = function () {
            $global.exportGridToExcel($scope.summaryGridOptions, "Sales_Agent_Summary", fileFrom(), fileTo());
        };

        function setReportData(data) {
            $scope.labelCounts = {
                totalSalesAgents: data && data.totalSalesAgents ? data.totalSalesAgents : 0,
                totalClientsBrought: data && data.totalClientsBrought ? data.totalClientsBrought : 0,
                totalActiveClients: data && data.totalActiveClients ? data.totalActiveClients : 0,
                totalServices: data && data.totalServices ? data.totalServices : 0,
                totalQty: data && data.totalQTY ? $scope.inrFilter(data.totalQTY) : "0.00",
                totalGtv: data && data.totalGTV ? $scope.inrFilter(data.totalGTV) : "0.00"
            };
            $scope.reportsData = data && data.reports ? data.reports : [];
            let salesAgents = data && data.salesAgents ? data.salesAgents : [];
            salesAgents.forEach(function (agent) {
                agent.agentStatus = getAgentStatus(agent);
            });
            // agents who are not in this city's sales team (other city, removed, test accounts) are shown
            // only when they have business here - so the list matches the Sales Team page
            $scope.salesAgentsData = salesAgents.filter(function (agent) {
                return agent.agentStatus !== NOT_IN_TEAM || agent.servicesCount > 0;
            });

            if ($scope.summaryGridOptions.api) {
                $scope.summaryGridOptions.api.setRowData($scope.salesAgentsData);
            }
            // keep the selected sales agent only if it is still in the new data
            let stillPresent = $scope.salesAgentsData.some(function (agent) {
                return agent.salesAgentName === $scope.selectedSalesAgent;
            });
            if (!stillPresent) {
                $scope.selectedSalesAgent = null;
            }
            $scope.setDetailsRows();
        }

        // leads assigned to a sales agent (with the agent's user id) that have a client mobile.
        // personIncharge without inchargeUserId comes from the old sales app, where it holds the
        // client's own contact person - those are not sales agents and are left out.
        // Approval is not required: acquired clients show their business before they are approved.
        function loadLeads() {
            if ($scope.leads) {
                return $q.when($scope.leads);
            }
            return salesAgentService.retrieveAllLeads().then(function (res) {
                if (!res || res.status !== "Success" || !res.data) {
                    throw new Error("Unable to fetch leads from sales");
                }
                $scope.leads = res.data
                    .filter(function (lead) {
                        return lead.mobileNo && lead.personIncharge && lead.personIncharge.inchargeUserId && lead.personIncharge.name;
                    })
                    .map(function (lead) {
                        return {
                            salesAgentId: lead.personIncharge.inchargeUserId,
                            salesAgentName: lead.personIncharge.name,
                            salesAgentMobile: lead.personIncharge.mobileNo,
                            clientName: lead.name || lead.organizationName,
                            clientMobile: lead.mobileNo
                        };
                    });
                return $scope.leads;
            });
        }

        // sales agent user id -> "Active" / "Inactive", from the same lists the Sales Team page uses; loaded once
        function loadTeamStatus() {
            if ($scope.teamStatusById) {
                return $q.when($scope.teamStatusById);
            }
            return $q.all([
                salesAgentService.getAllSalesAgents(true),
                salesAgentService.getAllSalesAgents(false)
            ]).then(function (results) {
                let statusById = {};
                [[results[0], 'Active'], [results[1], 'Inactive']].forEach(function (pair) {
                    let res = pair[0];
                    if (res && res.status == "Success" && Array.isArray(res.data)) {
                        res.data.forEach(function (agent) {
                            if (agent.userId) {
                                statusById[agent.userId] = pair[1];
                            }
                        });
                    }
                });
                $scope.teamStatusById = statusById;
                return statusById;
            }).catch(function (err) {
                // the report still works without the status column
                console.error("Unable to load the sales team list", err);
                return null;
            });
        }

        function normalizeMobile(mobile) {
            let digits = (mobile || "").toString().replace(/\D/g, "");
            return digits.length > 10 ? digits.slice(-10) : digits;
        }

        // the report rows carry the agent's name and mobile; the leads tell which agent id they belong to
        function getAgentStatus(agent) {
            if (!$scope.teamStatusById || !$scope.leads) {
                return "";
            }
            let mobile = normalizeMobile(agent.salesAgentMobile);
            let lead = mobile ? $scope.leads.find(function (l) {
                return normalizeMobile(l.salesAgentMobile) === mobile;
            }) : null;
            if (!lead) {
                lead = $scope.leads.find(function (l) {
                    return l.salesAgentName === agent.salesAgentName;
                });
            }
            return (lead && $scope.teamStatusById[lead.salesAgentId]) || NOT_IN_TEAM;
        }

        $scope.loadData = function () {
            $scope.fetchingstatus = true;
            $q.all([loadLeads(), loadTeamStatus()]).then(function (results) {
                let leads = results[0];
                if (!leads.length) {
                    growl.error("No leads with a sales agent found");
                    setReportData(null);
                    $scope.fetchingstatus = false;
                    return;
                }

                // no dates = all time
                let data = {
                    "city": $rootScope.loginData.city,
                    "leads": leads
                };
                if (!$scope.isAllTime) {
                    data.fromDate = $scope.vm.params.fromdate;
                    data.toDate = $scope.vm.params.todate;
                }

                salesAgentService.retrieveSalesAgentClientWiseReport(data).then(function (res) {
                    $scope.fetchingstatus = false;
                    if (res.status.toUpperCase() == "SUCCESS") {
                        setReportData(res.data);
                    } else {
                        if (res.error && res.error.message) {
                            growl.error(res.error.message);
                        }
                        setReportData(null);
                    }
                }).catch(function (err) {
                    $scope.fetchingstatus = false;
                    growl.error("Unable to load the report, please try again");
                    setReportData(null);
                });
            }).catch(function (err) {
                $scope.fetchingstatus = false;
                console.error(err);
                growl.error("Unable to fetch leads from sales, please try again");
                setReportData(null);
            });
        };

        $scope.opts = {
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "DD-MMM-YYYY",
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last 6 Months': [moment().subtract(6, 'months').add(1, 'days'), moment()]
            }
        };

        // keep the dates and the table state (filters, sort, page) in the URL, so Back / refresh show the same view
        tableState.page($scope, 'r', {
            controls: { d: { model: 'date', type: 'daterange' } },
            grids: { a: 'summaryGridOptions', c: 'detailsGridOptions' }
        });

        //Watch for date changes
        $scope.$watch('date', function (newDate) {
            let picker = $('#daterange3').data('daterangepicker');
            $scope.selectedRange = picker ? picker.chosenLabel : undefined;
            $scope.transactionChange();
        }, false);

        $scope.transactionChange = function () {
            let start = $scope.date && $scope.date.startDate;
            let end = $scope.date && $scope.date.endDate;
            if (!start && !end) {
                // no dates selected = all-time data
                $scope.isAllTime = true;
                $scope.vm.params.fromdate = null;
                $scope.vm.params.todate = null;
                $scope.loadData();
            } else if ($moment(start).isValid() && $moment(start).year() > 2010 && $moment(end).isValid() && $moment(end).year() > 2010) {
                $scope.isAllTime = false;
                $scope.vm.params.fromdate = $moment(start).format('DD-MMM-YYYY');
                $scope.vm.params.todate = $moment(end).format('DD-MMM-YYYY');
                $scope.loadData();
            } else {
                console.error("Invalid date, please select valid date range");
                growl.error("Invalid date, please select valid date range");
            }
        };

        // back to all-time data (the date watch reloads the report)
        $scope.showAllTime = function () {
            $scope.date = { startDate: null, endDate: null };
        };

        // the date watch reloads the report; the arrows step through dates, so they are off in all-time view
        // ranges the shared helper knows step like on the other reports; any other range
        // (Last 6 Months, a custom range) moves by its own length, so it does not shrink to one day
        const STEPPED_RANGES = ['Today', 'Yesterday', 'Last 7 Days', 'Last 30 Days', 'This Month'];

        function shiftRange(direction) {
            let start = $moment($scope.date.startDate).startOf('day');
            let end = $moment($scope.date.endDate).startOf('day');
            let days = end.diff(start, 'days') + 1;
            return {
                startDate: start.clone().add(direction * days, 'days'),
                endDate: end.clone().add(direction * days, 'days')
            };
        }

        $scope.nextDate = function () {
            if ($scope.isAllTime) {
                return;
            }
            $scope.date = STEPPED_RANGES.includes($scope.selectedRange)
                ? $global.getNextDateRanges($scope.selectedRange, $scope.date.endDate)
                : shiftRange(1);
        }

        $scope.previousDate = function () {
            if ($scope.isAllTime) {
                return;
            }
            $scope.date = STEPPED_RANGES.includes($scope.selectedRange)
                ? $global.getPrevDateRanges($scope.selectedRange, $scope.date.startDate)
                : shiftRange(-1);
        }
    });
